/* eslint-disable react/no-unescaped-entities */
import { LifeBuoyIcon } from '@/ui/icons';
import { Button, Text } from '@bsf/force-ui';
import { useState, useEffect } from '@wordpress/element';
import KeepSiteLiveModal from './KeepSiteLiveModal';

function ConnectDomain() {
	const [ isAlreadyDone, setIsAlreadyDone ] = useState( false );
	const [ notNow, setNotNow ] = useState( false );
	const [ isModalOpen, setIsModalOpen ] = useState( false );
	const [ timeLeft, setTimeLeft ] = useState( {
		days: 0,
		hours: 0,
		minutes: 30,
		seconds: 0,
	} );
	const [ isOfferExpired, setIsOfferExpired ] = useState( false );
	const offerEndTime = useState( () => {
		const stored = window.localStorage.getItem(
			'zipwp_connect_domain_offer_end'
		);
		if ( stored ) {
			return parseInt( stored, 10 );
		}
		const endTime = Date.now() + ( 30 * 60 * 1000 );
		window.localStorage.setItem( 'zipwp_connect_domain_offer_end', endTime );
		return endTime;
	} )[ 0 ];

	const userPlan = gettingStartedVars?.zip_plans?.active_plan?.slug || 'free';
	const cloudTrialAddons =
		gettingStartedVars?.zip_addons?.addons?.length || 0;

	const isFreePlan = userPlan === 'free' || userPlan === 'hobby';
	const isProBusinessPlan = userPlan === 'pro' || userPlan === 'business';

	const handleConnectDomain = () => {
		if ( ( isFreePlan || isProBusinessPlan ) && ! cloudTrialAddons ) {
			setIsModalOpen( true );
		} else {
			handleModalConfirm();
		}
	};

	const handleModalConfirm = () => {
		const app_url = 'https://app.zipwp.com';
		const utm_source = 'zipwp-client-adminbar';
		const utm_medium = 'connect-domain-cta';
		const site_uuid = gettingStartedVars?.siteDetails?.uuid || '';

		const paidUrl = `${ app_url }/sites?uuid=${ site_uuid }&utm_source=${ utm_source }&utm_medium=${ utm_medium }`;
		let url;
		if ( isFreePlan && ! cloudTrialAddons ) {
			url = `${ app_url }/plans?source=choose_plan&uuid=${ site_uuid }&plan=cloud-trial`;
		} else if ( isProBusinessPlan && ! cloudTrialAddons ) {
			url = `${ app_url }/plans?source=choose_plan&uuid=${ site_uuid }&plan=cloud-free-trial`;
		} else {
			url = paidUrl;
		}
		window.open( url, '_blank' );
		setIsModalOpen( false );
	};

	// Calculate 30-minute countdown timer
	useEffect( () => {
		const calculateTimeLeft = () => {
			const difference = offerEndTime - Date.now();

			if ( difference > 0 ) {
				setTimeLeft( {
					days: Math.floor( difference / ( 1000 * 60 * 60 * 24 ) ),
					hours: Math.floor(
						( difference / ( 1000 * 60 * 60 ) ) % 24
					),
					minutes: Math.floor( ( difference / 1000 / 60 ) % 60 ),
					seconds: Math.floor( ( difference / 1000 ) % 60 ),
				} );
			} else {
				setTimeLeft( { days: 0, hours: 0, minutes: 0, seconds: 0 } );
				setIsOfferExpired( true );
			}
		};

		calculateTimeLeft();
		const timer = setInterval( calculateTimeLeft, 1000 );

		return () => clearInterval( timer );
	}, [ offerEndTime ] );

	useEffect( () => {
		window.zipwpOpenKeepSiteLive = () => setIsModalOpen( true );
	}, [] );

	if ( isAlreadyDone || notNow ) {
		return null; // Don't render if already done or not now
	}

	return (
		<>
			<div className="bg-white border border-[#E5E7EB] rounded-lg p-6 mx-0">
				<div className="flex items-center gap-1.5 mb-4">
					<LifeBuoyIcon />
					<Text className="text-lg font-semibold text-[#111827]">
						Connect a Domain
					</Text>
				</div>

				<p className="text-gray-600 mb-6 text-sm">
					You're almost there. Connect your domain to launch. You can
					continue working on your site during or after this step.
				</p>

				<div className="flex gap-3">
					<button
						className="border-none cursor-pointer transition-colors duration-300 ease-in-out font-semibold focus:ring-2 focus:ring-toggle-on focus:ring-offset-2 disabled:text-text-disabled p-2.5 rounded-md text-sm [&>svg]:size-5 gap-1 text-text-on-color hover:bg-button-secondary-hover shadow-xs focus:shadow-none disabled:shadow-none disabled:bg-button-disabled disabled:outline-button-disabled bg-[#3D4592] h-10 w-36 "
						onClick={ handleConnectDomain }
					>
						Connect Domain
					</button>
					<Button
						variant="outline"
						className="h-10 w-36"
						onClick={ () => setIsAlreadyDone( true ) }
					>
						I've already done
					</Button>
					<Button
						variant="ghost"
						className="text-gray-700"
						onClick={ () => setNotNow( true ) }
					>
						Not Now
					</Button>
				</div>
			</div>

			{ ( isFreePlan || isProBusinessPlan ) && ! cloudTrialAddons && (
				<KeepSiteLiveModal
					isOpen={ isModalOpen }
					onClose={ () => setIsModalOpen( false ) }
					onConfirm={ handleModalConfirm }
					timeLeft={ timeLeft }
					isOfferExpired={ isOfferExpired }
					isProBusinessPlan={ isProBusinessPlan }
				/>
			) }
		</>
	);
}

export default ConnectDomain;
